import React from 'react';
import PropTypes from 'prop-types';

import {Tag} from './Tag';
import {Wrapper} from './Wrapper';
import {TagBlock} from './TagBlock';
import {BoxNode} from '../BoxNode';
import {JointNode} from '../JointNode';
import {TitleNode} from '../TitleNode';
import {NodesWrapper} from './NodesWrapper';
import {Utilities} from '@learningblocks/exp-constants';
const {DESIGN_NODE_TYPE: NODE_TYPE} = Utilities;

import './style.scss';

/**
 * GroupE:
 *  - Group is reponsible for displaying the following NODE_TYPE:[ BOX_NODE, JOINT_NODE ]
 *  - Groups All Technique and Outcome Nodes associated with a Step
 *  - Used in DesignViewFour
 */
export function GroupE(props) {
  const onDropStep = React.useCallback((params) => {
    props.onDropStep({...params, groupId: props.groupId});
  }, []);

  const onRemoveStep = React.useCallback((params) => {
    props.onRemoveStep({...params, groupId: props.groupId});
  }, []);

  const titleNode = (node) => {
    return React.cloneElement(props.titleNode, {
      ...props.titleNode.props,
      key: node.nodeId,
      nodeId: node.nodeId,
      onDropStep: onDropStep,
      onRemoveStep: onRemoveStep,
      nodeTitle: node.nodeTitle,
      nodeComponents: node.nodeComponents,
    });
  };

  const boxNode = (node) => {
    return React.cloneElement(props.boxNode, {
      ...props.boxNode.props,
      key: node.nodeId,
      nodeId: node.nodeId,
      onDropStep: onDropStep,
      onRemoveStep: onRemoveStep,
      nodeComponents: node.nodeComponents,
    });
  };

  const jointNode = (node) => {
    return React.cloneElement(props.jointNode, {
      ...props.jointNode.props,
      key: node.nodeId,
      nodeId: node.nodeId,
      onDropStep: onDropStep,
      onRemoveStep: onRemoveStep,
      nodeComponents: node.nodeComponents,
    });
  };

  const groupNode = (node) => {
    switch (node.nodeType) {
      case NODE_TYPE.TITLE_NODE:
        return titleNode(node);
      case NODE_TYPE.BOX_NODE:
        return boxNode(node);
      case NODE_TYPE.JOINT_NODE:
        return jointNode(node);
      default:
        return null;
    }
  };

  const className = `design-view__groupE ${props.className}`;

  return (
    <Wrapper className={className}>
      <TagBlock
        className='design-view__groupE_titleBlock'
        color={props.groupColor}>
        <Tag
          text={props.groupTag}
          color={props.groupColor}
          className='design-view__groupE_titleBlock--title'
        />
      </TagBlock>
      <NodesWrapper
        className='design-view__groupE_nodes'
        color={props.groupColor}>
        {props.groupNodes.map(groupNode)}
      </NodesWrapper>
    </Wrapper>
  );
}

GroupE.propTypes = {
  /**
   * groupId
   */
  groupId: PropTypes.number,
  /**
   * Main title of group
   */
  groupTag: PropTypes.string,
  /**
   * Theme color of group
   */
  groupColor: PropTypes.string,
  /**
   * List of Nodes in Group
   */
  groupNodes: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Unqiue Id for the node
       */
      nodeId: PropTypes.number,
      /**
       * Type of Node in Group
       */
      nodeType: PropTypes.oneOf(['TITLE_NODE', 'BOX_NODE', 'JOINT_NODE']),
      /**
       * Title for the node [ occurs with TITLE_NODE ]
       */
      nodeTitle: PropTypes.string,
      /**
       * List of components in node
       */
      nodeComponents: PropTypes.arrayOf(PropTypes.object),
      /**
       * Function for when Step is dropped in Node
       */
      onDropStep: PropTypes.func,
      /**
       * Function for when a Step is removed from Node
       */
      onRemoveStep: PropTypes.func,
    })
  ),
};

GroupE.defaultProps = {
  className: '',
  groupNodes: [],
};
